<!-- images gallery mobile[START] -->
<div class="md:hidden mobile-cards-image" [class.conditional-display-for-combo-rooms]="isCombo && isMobile"
  *ngIf="dataSource?.mainPicture">
  <img [ngSrc]="dataSource.mainPicture.webp" class="w-full h-full object-cover" height="200" width="300"
    [alt]="dataSource?.mainPicture?.alt" (error)="dataSource.mainPicture.webp = cdnUrl + '/images/no-image.jpg'" />
</div>
<!-- images gallery mobile[END] -->
<div class="pdp-cards-wrapper relative flex flex-col p-4 md:!rounded-lg bg-white min-h-[11.5rem]"
  [class.!p-0]="isCombo && isMobile">
  <!-- card's header[START] -->
  <!-- card's header[END] -->

  <div class="flex flex-col items-start w-full justify-between gap-4 md:items-stretch"
    [class.!pt-0]="isCombo && isMobile">
    <div *ngFor="let roomInfo of dataSource?.roomInfos; let i = index"
      class="flex items-stretch gap-6 flex-grow flex-col md:flex-row w-full {{isCombo ? 'pt-9' : roomInfo?.roomDetail?.nonRefundable ? 'pt-0' : 'pt-12'}}"
      [class.conditional-display-for-combo-rooms]="isCombo && isMobile"
      [class.pb-4]="(dataSource?.roomInfos?.length && dataSource!.roomInfos.length > 1)" [class.border-bottom]="
      (dataSource?.roomInfos?.length && dataSource!.roomInfos.length > 1) &&
      isCombo || (
        dataSource!.roomInfos.length > 1 &&
        !(i === dataSource!.roomInfos.length - 1)
      )">

      <div
        class="flex flex-col items-start md:flex-row md:items-center justify-between absolute pb-2 {{ isCombo ? '-mt-10' : '-mt-14' }}"
        style="width: calc(100% - 2rem);" [class.border-bottom]="!isCombo" *ngIf="!roomInfo?.roomDetail?.nonRefundable">
        <h3 class="flex justify-between items-center text-base font-bold text-black" *ngIf="!isCombo || !isMobile">
          {{ (i === 0) && dataSource?.foreignName ? dataSource?.foreignName : (i === 0) && dataSource?.name ?
           dataSource?.name  :
            comboRoomName }} 
        </h3>
        <button mat-button color="primary"
          (click)="showModalRooms(i === 0 ? dataSource.id : dataSource?.secondId!, roomInfo)"
          class="icon-arrow-button !hidden md:!flex">
          <span class="text-blue-500 text-sm !font-medium">اطلاعات بیشتر</span>
          <i class="ico-Left text-2xl"></i>
        </button>
      </div>

      <div class="h-[100px] w-[100px] hidden md:block cursor-pointer" [class]="(!isCombo && i !== 0) ? 'opacity-0' : ''"
        *ngIf="dataSource?.mainPicture" (click)="showModalRooms(dataSource.id, roomInfo)">
        <img class="rounded-lg object-cover !h-[100%] !w-[100%]" [alt]="dataSource.mainPicture.alt"
          [ngSrc]="(!isCombo || i === 0) ? dataSource?.mainPicture?.thumbnailUrl ?? '' : secondComboRoomImage!" (error)="
            dataSource.mainPicture.thumbnailUrl =
              cdnUrl + '/images/no-image.jpg'
          " height="100" width="100" />
      </div>
      <div class="h-[100px] w-[100px] hidden md:block" [class]="i !== 0 ? 'opacity-0' : ''"
        *ngIf="!dataSource.mainPicture">
        <img class="rounded-lg object-cover h-full w-full" [alt]="'no image'"
          [ngSrc]="'assets/images/no-image-hotel.svg'" height="100" width="100" alt>
      </div>

      <!-- TODO replace true with right condition (combo rooms exists) -->
      <!-- [class.my-3]="!dataSource.mainPicture" -->
      <div class="w-full flex items-start md:items-center flex-col md:flex-row flex-grow gap-4">

        <div class="flex flex-col flex-grow w-full gap-4 h-full"
          [class.justify-between]="roomInfo.roomInfoHeader.promotionId">
          <ul class="flex flex-col md:grid md:grid-cols-3 gap-2">
            <li class="flex items-center gap-1">
              <i class="ico-Profile text-xl text-black-300"></i>
              <span class="text-muted text-sm md:text-xs lg:text-sm">
                {{ roomInfo?.roomCapacity?.adultCapacity }} بزرگسال،
                {{ roomInfo?.roomCapacity?.infantCapacity }} خردسال
              </span>
            </li>

            <li class="flex items-center gap-1" *ngIf="roomInfo?.roomCapacity?.extraCapacity">
              <i class="ico-ProfileAdd text-2xl text-black-300"></i>
              <span class="text-muted text-sm md:text-xs lg:text-sm">
                نفر اضافه
              </span>
              <span *ngIf="roomInfo?.roomCapacity?.extraCapacity && roomInfo?.roomCapacity?.extraCapacityPrice"
                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded">
                با هزینه
              </span>
            </li>





            <li class="flex items-center gap-1" *ngIf="dataSource.isHourly">
              <i class="ico-TimeCircle text-2xl text-black-300"></i>
              <span class="text-muted text-sm md:text-xs lg:text-sm">رزرو
                ساعتی</span>
            </li>
          </ul>
          <ul class="flex flex-col md:grid md:grid-cols-1 md:grid-rows-1 gap-2">
            <li class="flex items-center gap-1">
              <i class="ico-Breakfast text-2xl text-black-300"></i>
              <span *ngIf="roomInfo?.roomDetail?.lunch || roomInfo?.roomDetail?.dinner"
                class="text-muted text-sm md:text-xs lg:text-sm flex">

                <span *ngIf="roomInfo?.roomDetail?.lunch">
                  {{roomInfo?.roomDetail?.lunch ? ' ناهار' : ''}}
                </span>
                <span *ngIf="roomInfo?.roomDetail?.dinner && roomInfo?.roomDetail?.lunch" class="mx-2"> + </span>
                <span *ngIf="roomInfo?.roomDetail?.dinner">
                  {{roomInfo?.roomDetail?.dinner ? ' شام' : ''}}
                </span>
                <span *ngIf="roomInfo?.roomDetail?.dinner || roomInfo?.roomDetail?.lunch" class="mx-2"> + </span>
              </span>
              <span class="flex items-center lg:text-sm md:text-xs text-muted text-sm w-full">

                صبحانه
                <span *ngIf="!roomInfo?.roomDetail?.breakfast"
                  class="bg-gray-200 mx-1 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded">

                  ندارد
                </span>
                <div class="flex items-center justify-center flex-wrap mr-2"
                  *ngIf="roomInfo?.roomDetail?.breakfast && breakFastType?.length">
                  <span *ngFor="let item of breakFastType"
                    class="bg-gray-200 whitespace-nowrap mb-2 text-metal-500 text-sm font-medium mx-1 px-2.5 py-0.5 rounded">
                    {{item?.name}}
                  </span>

                </div>

              </span>

            </li>
          </ul>
          <ul class="flex flex-col md:grid md:grid-cols-1 md:grid-rows-1 gap-2">
            <li class="flex items-center gap-1" *ngIf="roomInfo?.roomDetail?.nonRefundable">
              <i class="ico-Close text-xl text-black-300"></i>
              <span class="text-muted text-sm md:text-xs lg:text-sm">بدون بازگشت
                وجه</span>
            </li>


            <li>
              <button mat-button color="primary" *ngIf="!roomInfo?.roomDetail?.nonRefundable"
                (click)="showModalRooms(dataSource.id,roomInfo)" class="icon-arrow-button flex md:!hidden">
                <span>اطلاعات بیشتر</span>
                <i class="ico-Left text-2xl"></i>
              </button>
            </li>
          </ul>

          <p class="hidden md:flex items-center gap-2 -mt-2"
            *ngIf="(!roomInfo.reservable && !roomInfo.letMeKnow) && !isCombo">
            <i class="ico-DangerTriangle ico-xl text-black-300"></i>
            <span class="text-black-300 text-xs lg:text-sm">
              <ng-container *ngIf="roomInfo?.canReserveByTour && outOfPackagePeriod !== 0;else watingListDesktopDescription">
                ظرفیت اتاق پرشده، اما میتوانید از طریق 
                <span class="text-blue-500">خرید تور</span>
                 اقدام به رزرو کنید.
              </ng-container>
              <ng-template #watingListDesktopDescription>
                  <ng-container *ngIf="outOfPackagePeriod !== 0; else desktopPackageText">
                    در صورت تمایل برای قرار گرفتن در اولویت “لیست  انتظار” کلیک کنید.
                  </ng-container>
                  <ng-template #desktopPackageText>
                    ظرفیت اتاق پر شده، اما میتوانید از طریق 
                    <span class="text-blue-500">خرید پکیج</span>
                     اقدام به رزرو کنید.
                  </ng-template>
              </ng-template>
            </span>
          </p>

          <div
            class="bg-red-50 flex items-center justify-between w-full p-2 text-sm rounded-md overflow-hidden gap-3 lg:max-w-full"
            *ngIf="
              roomInfo.reservable &&
              roomInfo?.roomInfoHeader?.promotionId &&
              roomInfo.roomInfoHeader.title
            ">
            <em class="bg-white text-red-400 font-semi-bold px-2 py-1 whitespace-nowrap"
              style="font-style: normal; border-radius: 4px">{{ roomInfo.roomInfoHeader.title }}</em>

            <div class="flex items-center gap-4">
              <iho-count-down *ngIf="roomInfo.roomInfoHeader?.countdownTimer"
                [Dates]="roomInfo.roomInfoHeader.countdownTimer" />
              <p class="text-black-400 ml-2 overflow-hidden text-xs">
                {{ roomInfo.roomInfoHeader.description }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col gap-2 justify-end w-full self-end md:max-w-none md:w-44 md:min-w-[11rem] density-settings-0">
          <ng-container *ngIf="!roomInfo?.noPrice">
            <div class="flex w-full items-center justify-end gap-2" *ngIf="
                !roomInfo.roomPrice?.price?.oldPrice &&
                roomInfo.roomPrice?.discount &&
                roomInfo.roomPrice.discount >= 5
              ">
              <span class="price-off text-black-200 mx-2 after:content-[''] line-through-price text-xs !font-normal">{{
                roomInfo.roomPrice?.price?.boardPrice
                | toToman
                | number : '2.'
                }}</span>
              <div class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                <span class="text-sm text-green-800 !font-medium">{{ roomInfo.roomPrice?.discount }}%</span>
              </div>
            </div>

            <div class="flex w-full items-center gap-1 justify-end md:justify-center" *ngIf="roomInfo.roomPrice">
              <span class="text-xs text-muted">{{ roomInfo.roomPrice?.price?.nights }} شب</span>
              <span class="text-black-500 text-xl font-bold">{{
                roomInfo.roomPrice?.price?.ihoPrice | toToman |
                number :
                '2.'
                }}</span>
              <span class="text-xs text-muted">تومان</span>
            </div>

            <!-- <iho-counter *ngIf="roomInfo.reservable; else otherButtons" [min]="0" [max]="10" (decreaseEvent)="decreaseRoomCount()" (increaseEvent)="increaseRoomCount()" [removeCount]="resetCount"/> -->
          </ng-container>
          <div class="flex flex-col gap-2 items-end self-end flex-grow w-full" *ngIf="!isCombo">
            <span class="block text-xs font-semi-bold text-red-400 self-end md:text-center md:w-full"
              *ngIf="roomInfo.lastRoomLeft">آخرین اتاق باقیمانده</span>
            <iho-counter *ngIf="roomInfo.reservable; else nonReservableButtons"
              (click)="outOfPackagePeriod !== 0 ? showLimitsModal(roomInfo) : shwoModalPackages($event,dataSource.id,outOfPackagePeriod)"
              [min]="0" [max]="roomInfo.lastRoomLeft  ? 1 : 10" type="hotel" [outOfPackagePeriod]="outOfPackagePeriod"
              class="min-w-[12rem] max-w-[50%] md:w-full md:min-w-[unset] md:max-w-none" [roomId]="dataSource.id"
              [disable]="roomInfo.roomAvailableDate.checkInLimit || roomInfo.roomAvailableDate.checkOutLimit || (InNightLimitRange() && !dataSource.isHourly) || (dataSource.isHourly && nightsToStand > 1)"
              (decreaseEvent)="decreaseRoomCount(roomInfo?.roomDetail?.nonRefundable)"
              (increaseEvent)="increaseRoomCount(roomInfo?.roomDetail?.nonRefundable)" />

            <ng-template #nonReservableButtons>
              <ng-container *ngIf="!hotelIsFull; else fullCapacityBtn">
                <div class="min-w-[12rem] max-w-[50%] md:w-full md:min-w-[unset] md:max-w-none"
                  *ngIf="roomInfo?.letMeKnow">
                  <button
                    (click)="outOfPackagePeriod !== 0 ? navigateToFollowReservation(!!roomInfo?.roomDetail?.nonRefundable, roomInfo) : shwoModalPackages($event,dataSource.id,outOfPackagePeriod)"
                    class="notifyMe w-full h-11 text-base !font-semi-bold flex justify-center items-center flex-shrink-0 text-black-500">
                    خبرم کن
                  </button>
                </div>

                <ng-container *ngIf="!roomInfo?.letMeKnow">
                  
                  <p class="flex md:hidden items-center gap-2">
                    <i class="ico-DangerTriangle ico-xl text-black-300"></i>
                    <span class="text-black-300 text-xs lg:text-sm">
                      <ng-container *ngIf="roomInfo?.canReserveByTour && outOfPackagePeriod !== 0;else waitingListMobileDescription">
                        ظرفیت اتاق پرشده، اما میتوانید از طریق 
                        <span class="text-blue-500">خرید تور</span>
                         اقدام به رزرو کنید.
                      </ng-container>
                      <ng-template #waitingListMobileDescription>
                        <ng-container *ngIf="outOfPackagePeriod !== 0; else mobilePackageText">
                          در صورت تمایل برای قرار گرفتن در اولویت “لیست  انتظار” کلیک کنید.
                        </ng-container>
                        <ng-template #mobilePackageText>
                          ظرفیت اتاق پر شده، اما میتوانید از طریق 
                          <span class="text-blue-500">خرید پکیج</span>
                           اقدام به رزرو کنید.
                        </ng-template>
                      </ng-template>
                      </span>
                  </p>
                  <div
                  
                    class="flex flex-row-reverse md:flex-col gap-1 justify-between items-stretch md:items-center w-full flex-grow">
                    <button
                      (click)="outOfPackagePeriod !== 0 ? navigateToFollowReservation(!!roomInfo?.roomDetail?.nonRefundable, roomInfo) : shwoModalPackages($event,dataSource.id,outOfPackagePeriod)"
                      class="joinQueue w-full h-11 text-base !font-semi-bold flex justify-center items-center text-black-500">
                      <ng-container *ngIf="roomInfo?.canReserveByTour && outOfPackagePeriod !== 0;else watingListText">
                        خرید تور
                      </ng-container>
                      <ng-template #watingListText>
                        <ng-container *ngIf="outOfPackagePeriod !== 0; else packageText">
                          لیست انتظار
                        </ng-container>
                        <ng-template #packageText>
                          خرید پکیج
                        </ng-template>
                      </ng-template>
                    </button>

                    <ng-container *ngIf="!roomInfo?.canReserveByTour">
                      <div *ngIf="!roomInfo?.canReserveByTour" class="iho-datepicker w-full md:hidden">
                        <button ihoDatepicker [allowToShow]="false" [isMobile]="true"
                          (click)="outOfPackagePeriod !== 0 ? emitAvailableDates(roomInfo.roomAvailableDate.dates) : shwoModalPackages($event,dataSource.id,outOfPackagePeriod)"
                          mat-button color="primary" class="!font-semi-bold w-full !h-11 flex-grow">
                          تاریخ های قابل رزرو
                        </button>
                      </div>
  
                      <div class="iho-datepicker w-full hidden md:block">
                        <button ihoDatepicker [reservable]="true" [allowToShow]="false"
                          (click)="outOfPackagePeriod !== 0 ? emitAvailableDates(roomInfo.roomAvailableDate.dates) : shwoModalPackages($event,dataSource.id,outOfPackagePeriod)"
                          mat-button color="primary" class="w-full !h-11 flex-grow !text-base">
                          تاریخ های قابل
                          رزرو
                        </button>
                      </div>
                    </ng-container>

                  </div>
                </ng-container>
              </ng-container>

              <ng-template #fullCapacityBtn>
                <button
                  (click)="outOfPackagePeriod === 0 ? shwoModalPackages($event,dataSource.id,outOfPackagePeriod) : null"
                  mat-stroked-button color="warn"
                  class="icon-button !h-11 !flex items-center justify-center !font-semi-bold gap-2 text-red-500">
                  <i class="ico-LeftOver text-2xl text-red-500"></i>
                  <span class="text-base text-red-500">تکمیل ظرفیت</span>
                </button>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isCombo">
      <ng-container *ngTemplateOutlet="ComboRooms"></ng-container>
    </ng-container>
  </div>





  <ng-template #ComboRooms>
    <!-- mobile template -->
    <div *ngIf="isMobile" class="flex items-stretch w-full pb-4 combo-rooms-wrapper h-[250px]">
      <div class="flex flex-col items-start justify-between gap-2 h-full"
        [class]="comboRoomName ? 'pr-4' : 'border-left pl-4'">

        <div class="flex flex-col gap-2 items-start">
          <img class="rounded-lg object-cover h-full w-full" [alt]=""
            [ngSrc]="secondComboRoomImage ?? dataSource?.mainPicture?.thumbnailUrl ?? ''" (error)="
          dataSource.mainPicture.thumbnailUrl =
            cdnUrl + '/images/no-image.jpg'
        " height="180" width="180">

          <h3 class="text-base font-bold">{{ comboRoomName ?? dataSource?.name }}</h3>
        </div>

        <button mat-button color="primary"
          (click)="showModalRooms(roomId, comboRoomName ? dataSource?.roomInfos?.[1] : dataSource?.roomInfos?.[0])"
          class="icon-arrow-button flex md:!hidden">
          <span>اطلاعات بیشتر</span>
          <i class="ico-Left text-2xl"></i>
        </button>

      </div>
    </div>

    <!-- desktop template -->
    <div class="!hidden w-full md:!flex justify-between mt-2 relative" id="combo-rooms-info">
      <div class="indicator-dots absolute right-0 top-1 flex flex-col items-center gap-1">
        <span class="h-2 w-2 border border-solid border-black-100 rounded-full"></span>
        <span class="line"></span>
        <span class="h-2 w-2 border border-black-100 border-solid bg-black-100 rounded-full"></span>
      </div>
      <div class="flex flex-col gap-2 items-start mr-5">
        <div class="flex flex-col gap-2 items-start" *ngFor="let eachRoom of pdpUiService.comboRooms()[0]?.rooms">
          <h6 class="text-sm text-black font-semibold">{{ eachRoom.roomName }} </h6>
          <div class="flex items-center gap-4 justify-start text-xs">
            <p class="text-muted">ورود : {{ eachRoom.priceInfo.checkInDate }}</p>
            <p class="text-black-300 py-1 px-2 rounded bg-black-50">{{ eachRoom.priceInfo.nights }} شب </p>
            <p class="text-muted">خروج : {{ eachRoom.priceInfo.checkOutDate }}</p>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-end gap-2">
        <div class="flex w-full items-center gap-1 justify-end md:justify-center">
          <span class="text-sm text-muted">{{ pdpUiService.comboRooms()[0]?.totalPrice?.nights }} شب</span>
          <span class="text-black-500 text-2xl font-bold">{{
            pdpUiService.comboRooms()[0]?.totalPrice?.ihoPrice | toToman | number : '2.'
            }}</span>
          <span class="text-sm text-muted">تومان</span>
        </div>

        <button mat-flat-button color="primary" class="w-full !h-11 !text-base font-semi-bold"
          (click)="toggleComboSelection(pdpUiService.comboRooms()[0].combenationId)" [disabled]="disableComboBtn">
          انتخاب اتاق های ترکیبی
        </button>
      </div>

    </div>

  </ng-template>